module.exports = __webpack_public_path__ + "static/pic11-d9e39c8bf987cfe48a7aff0b47169898.jpg";